export const MAP_EASE_MIN = 9;
export const MAP_EASE_MAX = 11;

export const MAX_NUMBER_OF_LOCATIONS_IN_RESULT = 3;
